import React from 'react'
import './App.scss'
import ControlNavbarComponent from './components/navbar/ControlNavbar'
import ControlLoadInitialiseComponent from './components/load/ControlLoadInitialise'
import ControlBoardsComponent from './components/boards/ControlBoards'
import AppContextProvider from './context/AppContext'
import ControlAnalyticsComponent from './components/analytics/ControlAnalytics'

function App() {
    return (
        <AppContextProvider>
            <ControlLoadInitialiseComponent>
                <ControlAnalyticsComponent />
                <ControlNavbarComponent />
                <ControlBoardsComponent />
            </ControlLoadInitialiseComponent>
        </AppContextProvider>
    )
}

export default App
